import React, { useState } from 'react'
import Row from '../general/Row'
import Column from '../general/Column'
import styled from 'styled-components'
import ButtonPrimary from '../general/ButtonPrimary'
import Container from '../general/Container'
import Loader from '../general/Loader'
import ServiceCentersResultsList from './ServiceCentersResultsList'
import ServiceCentersResultsMap from './ServiceCentersResultsMap.jsx'


const StyledResultsContainer = styled.div`
  display: -ms-flexbox;
  display: flex;
  -ms-flex-align: start;
  align-items: flex-start;
  -ms-flex-pack: justify;
  justify-content: center;
  
  @media (max-width: 768px) {
      flex-wrap: wrap;
  }
`;

const StyledResultsMap = styled.div`
  flex: 0 100% !important;
  
  @media (min-width: 768px) {
    flex: 0 65% !important;
  }
`;




const StyledServiceCenter = styled.div`
  -ms-flex: 0 0 25%;
  flex: 0 0 25%;
  max-width: 25%;

  .service-center-state {
    margin-bottom: 16px;
    
    a {
      padding: 12px 24px;
      line-height: 1em;
      cursor: pointer;
      border-radius: 4px;
      border-style: solid;
      text-align: center;
      text-transform: uppercase;
    }
    
    .state-name {
      display: inline-block;
      margin-right: 8px;
      font-size: 14px;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.33;
      letter-spacing: .5px;
    }
    
    .state-total {
      display: inline-block;
      font-size: 12px;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.33;
      letter-spacing: .5px;
      color: #ccc;
    }
  }
`;

const StyledHeader = styled.h2`
  margin-bottom: 10px;
  font-size: 36px;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.19;
  text-transform: capitalize;
  text-decoration: none;
  text-align: center;
  color: #000;
`;

const StyledCountryContainer = styled.div`
  display: flex;
  flex: 0 0 50%;
  max-width: 50%;
  position: relative;
  padding-right: 15px;
  padding-left: 15px;
  
  @media (max-width: 768px) {
      max-width: 100%;
      flex: 0 0 100%;
  }
`;

const StyledCountryLink = styled.a`
  display: block;
  flex: 0 0 100%;
  max-width: 100%;
  border-radius: 100px;
  font-size: 14px;
  transition: all .3s ease-in-out;
  background: #000;
  border: 1px solid #000;
  color: #fff;
  padding: 12px 24px;
  line-height: 1em;
  cursor: pointer;
  border-style: solid;
  text-align: center;
  text-transform: uppercase;
  margin-bottom: 1rem;
  
  @media (max-width: 768px) {
    flex: 0 0 100%;
    max-width: 100%;
  }
  
  &:hover {
    background: #fff;
    border: 1px solid #000;
    color: #000;
  }
`;

const StyledStateContainer = styled.div`
  display: flex;
  flex: 0 0 25%;
  max-width: 25%;
  position: relative;
  padding-right: 15px;
  padding-left: 15px;
  
  @media (max-width: 768px) {
    max-width: 100%;
    flex: 0 0 100%;
  }
`;

const StyledStateLink = styled.a`
  display: block;
  flex: 0 0 100%;
  max-width: 100%;
  font-size: 14px;
  transition: all .3s ease-in-out;
  background: #fff;
  border: 1px solid #000;
  color: #000;
  padding: 12px 24px;
  line-height: 1em;
  cursor: pointer;
  border-style: solid;
  text-align: center;
  text-transform: uppercase;
  margin-bottom: 1rem;

  .state-name {
    display: inline-block;
    margin-right: 8px;
    font-size: 14px;
    font-weight: 600;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.33;
    letter-spacing: .5px;
  }

  .state-total {
    display: inline-block;
    font-size: 12px;
    font-weight: 600;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.33;
    letter-spacing: .5px;
    color: #ccc;
  }

  @media (max-width: 768px) {
    flex: 0 0 100%;
    max-width: 100%;
  }

  &:hover {
    background: #000;
    border: 1px solid #000;
    color: #fff;
  }
`;

const StyledReturnToServiceCenterCountries = styled.div`
  max-width: 25%;
  text-align: center;
  margin: 0 auto;

  @media (max-width: 768px) {
    max-width: 100%;
    flex: 0 0 100%;
  }

  a {
    display: block;
    flex: 0 0 100%;
    max-width: 100%;
    border-radius: 100px;
    font-size: 14px;
    transition: all .3s ease-in-out;
    background: #000;
    border: 1px solid #000;
    color: #fff;
    font-weight: 600;
    padding: 12px 24px;
    line-height: 1em;
    cursor: pointer;
    border-style: solid;
    text-align: center;
    text-transform: uppercase;
    margin-bottom: 1rem;

    @media (max-width: 768px) {
        flex: 0 0 100%;
        max-width: 100%;
    }

    &:hover {
        background: #fff;
        border: 1px solid #000;
        color: #000;
    }
  }
`;


interface Props {
  site: string | null;
  country: string;
  brandKey: string;
}

const ServiceCenterContainer: React.FC<Props> = ({ site, country, brandKey }) => {
  const [stage, setStage] = useState<number>(1);
  const [loading, setLoading] = useState<boolean>(false);
  const [results, setResults] = useState<any>([]);
  const [data, setData] = useState<string>('');
  const [error, setError] = useState<boolean>(false);
  const [errorMsg, setErrorMsg] = useState<string>('');
  const [selectCountry, setSelectCountry] = useState<string>('');
  const [state, setState] = useState<string>('');

const countrySelectClick = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
  setStage(1);
}


const getServiceCenters = (country: string, state?: string, stateName? : string) => (event: React.MouseEvent<HTMLDivElement>) => {
  if (stateName) {
  setState(stateName);
  }

  let data : any;
  setLoading(true);
  if (country === 'US') {
    setSelectCountry('United States');
  } else if (country === 'CA') {
    setSelectCountry('Canada');
  }

   if (!state) {
   data = {
    "Brand": site,
    "country": country
  }
} else {
    data = {
    "Brand": site,
    "country": country,
    "state": state
  }
}


  const apiUrl = 'https://dealer-api.fendergarage.com/search/service-centers';

  setData(JSON.stringify(data));
 // console.log('post data', data);

  const postData = {
    method: "POST",
    headers: {'Content-Type': 'application/json'},
    body: JSON.stringify(data)
  };

  fetch(apiUrl, postData)
  .then(res => res.json())
  .then(data => {
    console.log('response data', data);
    if(data) {
      setResults(data);
      setError(false);
      setErrorMsg('');
      setLoading(false);
      return;
    }
    else {
      setError(true);
      setResults([]);
      setLoading(false);
      setErrorMsg('No results found');
      return;
    }
  })
  .catch(error => {
    console.log('error', error);
    if (error.response) {
      console.log('error.response', error.response);
      console.log('error.response.data', error.response.data);
      console.log('error.response.status', error.response.status);
      console.log('error.response.headers', error.response.headers);
      setErrorMsg(error.response);
    }
    if (error.request) {
      console.log('error.request', error.request);
    }
    if (error.message) {
      console.log('error.message', error.message);
    }
    if(error.config) {
      console.log('error.config', error.config);
    }
    if(!errorMsg || errorMsg === ''){
      setErrorMsg(error);
    }
    setError(true);
    setResults([]);
    setLoading(false);
    return;
  });

if (state) {
  setStage(3);
} else {
setStage(2);
}
}

let serviceCenters = null;

if (results && results.data && results.data.length > 0) {
  serviceCenters = results.data.map((serviceCenter: any, index: number) => (
    <StyledStateContainer onClick={getServiceCenters(country,serviceCenter.code,serviceCenter.name)} key={index} className="service-center-state">
      <StyledStateLink href="#">
        <div className="state-name">{serviceCenter.name}</div>
        <div className="state-total">{serviceCenter.total}</div>
      </StyledStateLink>
    </StyledStateContainer>
  ));
}
return (
  <Container>
    <Row>
      <Column>
        {loading ? (
          <Loader />
        ) : (
          <>
            {stage === 1 && (
              <>
                <StyledHeader>{site} Authorized Service Centers</StyledHeader>

                <p>Please Note: For product service outside the U.S. and Canada, please contact either the Dealer from whom you purchased the product, or the Authorized Gretsch Distributor in your area for information and assistance.</p>

                <Row>
                  <StyledCountryContainer onClick={getServiceCenters(country)}>
                    <StyledCountryLink href="javascript:void(0);">United States</StyledCountryLink>
                  </StyledCountryContainer>
                  <StyledCountryContainer onClick={getServiceCenters(country)}>
                    <StyledCountryLink href="javascript:void(0);">Canada</StyledCountryLink>
                  </StyledCountryContainer>
                </Row>
              </>
            )}
            {stage === 2 && serviceCenters && (
              <>
                <StyledHeader>{site} Service Centers For {selectCountry}</StyledHeader>

                <p>Please Note: For product service outside the U.S. and Canada, please contact either the Dealer from whom you purchased the product, or the Authorized Gretsch Distributor in your area for information and assistance.</p>

                <Row>
                  {serviceCenters}
                </Row>
                <StyledReturnToServiceCenterCountries onClick={countrySelectClick}>
                    <a href="javascript:void(0);">Select a Different Country</a>
                  </StyledReturnToServiceCenterCountries>
              </>
            )}
            {stage === 3 && results && results.data && results.data.results && (
              <>
              <StyledHeader>{site} Service Centers For {state}</StyledHeader>
             <StyledResultsContainer>
            {/* <div class="showing-total">Showing 3</div> */}
             <ServiceCentersResultsList results={results} />
             <StyledResultsMap>
              <ServiceCentersResultsMap results={results.data.results} />
             </StyledResultsMap>
           </StyledResultsContainer>
           </>
            )}
          </>
        )}
      </Column>
    </Row>
  </Container>
);
}

export default ServiceCenterContainer
